import type { EvidenceStatementType, ReviewIssueType, ReviewMode, UserConfirmation } from "./types";

export interface ReviewAnswers {
  uncomfortableTruth: string;
  founderDeviation: string;
  affectedBusinessResult: string;
  correctionAction: string;
  verificationMetric: string;
  issueType: ReviewIssueType | "";
  energyLevel: 1 | 2 | 3 | 4 | 5 | null;
  fieldAnswer: string;
  focus: string;
  repetition: string;
  trust: string;
  decisionQuality: string;
  organization: string;
}

export interface ReviewStatementDraft {
  id: string;
  content: string;
  statementType: EvidenceStatementType;
  userConfirmation: UserConfirmation;
  verificationCondition?: string;
  falsificationCondition?: string;
}

export interface ReviewDraftData {
  reviewId: string;
  privateSourceId: string;
  dateKey: string;
  mode: ReviewMode;
  step: number;
  answers: ReviewAnswers;
  notApplicable: Array<keyof ReviewAnswers>;
  statements: ReviewStatementDraft[];
  startedAt: string;
  lastSavedAt: string;
}

export function createEmptyReviewAnswers(): ReviewAnswers {
  return {
    uncomfortableTruth: "",
    founderDeviation: "",
    affectedBusinessResult: "",
    correctionAction: "",
    verificationMetric: "",
    issueType: "",
    energyLevel: null,
    fieldAnswer: "",
    focus: "",
    repetition: "",
    trust: "",
    decisionQuality: "",
    organization: "",
  };
}

export function createEmptyReviewDraft(
  dateKey: string,
  mode: ReviewMode,
  now = new Date().toISOString(),
): ReviewDraftData {
  return {
    reviewId: crypto.randomUUID(),
    privateSourceId: crypto.randomUUID(),
    dateKey,
    mode,
    step: 0,
    answers: createEmptyReviewAnswers(),
    notApplicable: [],
    statements: [],
    startedAt: now,
    lastSavedAt: now,
  };
}

export function parseReviewDraft(rawText: string): ReviewDraftData {
  const parsed = JSON.parse(rawText) as ReviewDraftData;
  if (
    !parsed ||
    typeof parsed !== "object" ||
    typeof parsed.reviewId !== "string" ||
    typeof parsed.dateKey !== "string" ||
    !parsed.answers
  ) {
    throw new Error("CEO-REVIEW-011: 复盘草稿格式无效。");
  }
  return {
    ...parsed,
    notApplicable: Array.isArray(parsed.notApplicable) ? parsed.notApplicable : [],
  };
}
